/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetDisplayedPriceTask
 */
export interface SetDisplayedPriceTask {
    /**
     *
     * @type {string}
     * @memberof SetDisplayedPriceTask
     */
    priceMessageToDisplay?: string;
}

/**
 * Check if a given object implements the SetDisplayedPriceTask interface.
 */
export function instanceOfSetDisplayedPriceTask(
    value: object,
): value is SetDisplayedPriceTask {
    return true;
}

export function SetDisplayedPriceTaskFromJSON(
    json: any,
): SetDisplayedPriceTask {
    return SetDisplayedPriceTaskFromJSONTyped(json, false);
}

export function SetDisplayedPriceTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SetDisplayedPriceTask {
    if (json == null) {
        return json;
    }
    return {
        priceMessageToDisplay:
            json["priceMessageToDisplay"] == null
                ? undefined
                : json["priceMessageToDisplay"],
    };
}

export function SetDisplayedPriceTaskToJSON(
    value?: SetDisplayedPriceTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        priceMessageToDisplay: value["priceMessageToDisplay"],
    };
}
